import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { Decimal } from 'decimal.js';

import { CurrencyPipe } from '../../../base/pipes/currency.pipe';

@Component({
    selector: 'bs-betslip-taxation-liability',
    templateUrl: './betslip-taxation-liability.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BetslipTaxationLiabilityComponent {
    @Input() taxBackGiven: Decimal;

    constructor(
        private currencyPipe: CurrencyPipe,
        private sitecore: Sitecore,
    ) {}

    getTaxationMessage(): string {
        const amountWithCurrency = this.currencyPipe.transform(this.taxBackGiven, true);

        return interpolateDoubleBracesString(this.sitecore.betslip.messages.TaxBackGiven, { amount: amountWithCurrency });
    }
}
